import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import type { ResolverTag } from '@swf/core/enums';
import type { TranslationTag } from '@swf/core/types/i18n';

interface Props {
  textTranslation?: TranslationTag;
  linkTranslation: TranslationTag;
  resolverTag: ResolverTag;
}

const InfoLink: React.FC<Props> = ({ textTranslation, linkTranslation, resolverTag }) => (
  <div>
    {textTranslation && (
      <>
        <Translation {...textTranslation} />{' '}
      </>
    )}
    <Translation
      {...linkTranslation}
      values={{
        a: (msg: string) => <ResolverLink resolverTag={resolverTag}>{msg}</ResolverLink>
      }}
    />
  </div>
);

export default InfoLink;
